import springRadiance from "../img/buchete-de-primavara/1spring-radiance.webp";
import awakening from "../img/buchete-de-primavara/2awakening.webp";
import softlySpoken from "../img/buchete-de-primavara/5softly-spoken.webp";
import tulipReverie from "../img/buchete-de-primavara/8tulip-reverie.webp";
import delicateSpring from "../img/buchete-de-primavara/9delicate-spring.webp";
import springPoetry from "../img/buchete-de-primavara/14spring-poetry.webp";
import bloom from "../img/cele-mai-vindute/Bloom.webp";
import etherealBlush from "../img/buchete-de-primavara/18ethereal-blush.webp";
// import colourfulGlow from "../img/buchete-de-primavara/19colourful-glow.webp";
import sunshineBlooms from "../img/buchete-de-primavara/21sunshine-blooms.webp";
import paleSymphony from "../img/buchete/1pale-symphony.webp";
import petalEmbrace from "../img/buchete/6petal-embrace.webp";
import floralElegance from "../img/buchete/7floral-elegance.webp";
import illume from "../img/buchete/14illume.webp";
import featherlight from "../img/buchete/15featherlight.webp";
import hydrangeaCascade from "../img/buchete/18cascade.webp";
import belle from "../img/buchete/19belle.webp";
import petalJewel from "../img/buchete/21petal-jewel.webp";
import whispery from "../img/buchete/23whispery.webp";
import roselight from "../img/buchete/24roselight.webp";
import snowdrop from "../img/buchete/26snowdrop.webp";
// import pastelBreeze from "../img/buchete/27pastel-breeze.webp";
import lunarBliss from "../img/buchete/28lunar-bliss.webp";
import soothe from "../img/buchete/29soothe.webp";
import nobility from "../img/buchete/32nobility.webp";
import orchidMist from "../img/buchete/33orchid-mist.webp";
import fuchsiaEmbrace from "../img/buchete/34fuchsia-embrace.webp";
import bloomscape from "../img/buchete/35bloomscape.webp";
import majestic from "../img/buchete/36majestic.webp";
import marshmallowBloom from "../img/buchete/37marshmallow-bloom.webp";
import angelsTouch from "../img/buchete/38angels-touch.webp";
import pinkMist from "../img/buchete/39pink-mist.webp";
import delicacy from "../img/buchete/40delicacy.webp";
import buttercream from "../img/buchete/46buttercream.webp";
import roseDream from "../img/buchete/49rose-dream.webp";
import aura from "../img/buchete/50aura.webp";
import floralFantasy from "../img/buchete/53floral-fantasy.webp";
import adore from "../img/buchete/54adore.webp";
import eden from "../img/buchete/55eden.webp";
import moonveil from "../img/buchete/56moonveil.webp";
import noblespring from "../img/new/022noble.webp";
import mixeddreams from "../img/new/023mixeddreams.webp";
import secretmix from "../img/new/024secretmix.webp";
import ethernaldream from "../img/new/021eternaldream.webp";
import springwaltz from "../img/new/014springwaltz.webp";
import royalgarden from "../img/new/017royalgarden.webp";
import pinkdelight from "../img/new/016pinkdelight.webp";
import silkspring from "../img/new/018silkspring.webp";
import marigold from "../img/new/001marigold.webp";
import hydrangeamelody from "../img/new/015hidrangeamelody.webp";
import laurel from "../img/new/003laurel.webp";
import primrose from "../img/new/002primrose.webp";
import zinnia from "../img/new/004zinnia.webp";
import colordance from "../img/new/013colordance.webp";
import firstlight from "../img/new/019firstlight.webp";
import springtimeromance from "../img/new/010springtimeromance.webp";
import softrhapsody from "../img/new/011softrhapsody.webp";
import ivy from "../img/new/005Ivy.webp";
import alpinePetals from "../img/feb2026/alpine_petals.webp";
import blushCascade from "../img/feb2026/blush_cascade.webp";
import blushTheory from "../img/feb2026/blush_theory.webp";
import lunaBloom from "../img/feb2026/luna_bloom.webp";
import moonlitRoses from "../img/feb2026/moonliit_roses.webp";
import petalMuse from "../img/feb2026/petal_muse.webp";
import pinkAura from "../img/feb2026/pink_aura.webp";
import pureWhite from "../img/feb2026/pure_white.webp";
import signaturePink from "../img/feb2026/signature_pink.webp";
import wildHoney from "../img/feb2026/wild_honey.webp";
import aspenRose from "../img/feb2026/10aspen_rose.webp";
import blushingTulle from "../img/feb2026/11blushing_tulle.webp";
import cloudyWhite from "../img/feb2026/12cloudy_white.webp";
import lavenderDream from "../img/feb2026/13Lavender_dream.webp";
import oliveBlossom from "../img/feb2026/14olive_blossom.webp";
import petalMist from "../img/feb2026/15Petal_mist.webp";
import royalOrchid from "../img/feb2026/16royal_orchid.webp";
import sandyRose from "../img/feb2026/17Sandy_Rose.webp";
import sweetMint from "../img/feb2026/18sweet_mint.webp";
import velvetMauve from "../img/feb2026/19velvet_mauve.webp";
//501-600
const optMartie = [
  {
    id: 587,
    name: "Aspen Rose",
    price: "730 lei",
    description:
      "Buchet format din trandafiri, eustoma, crizantema, crengute genista si eucalipt. ",
    images: [aspenRose],
  },
  {
    id: 588,
    name: "Blushing Tulle",
    price: "800 lei",
    description:
      "Buchet format din lalele, trandafir de tip bujor, crizanteme, frezie si eucalipt. ",
    images: [blushingTulle],
  },
  {
    id: 589,
    name: "Lavender Dream",
    price: "900 lei",
    description:
      "Buchet format din hortensie, trandafir, eustome si eucalipt. ",
    images: [lavenderDream],
  },
  {
    id: 591,
    name: "Olive Blossom",
    price: "750 lei",
    description:
      "Buchet format din hortensie, crizanteme, frezie si eucalipt. ",
    images: [oliveBlossom],
  },
  {
    id: 592,
    name: "Sandy Rose",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor, trandafir cu un cap,orhidee, crizanteme, eustoma, azothamus si eucalipt. ",
    images: [sandyRose],
  },
  {
    id: 593,
    name: "Cloudy White",
    price: "650 lei",
    description:
      "Buchet format din crizanteme, eustome, trandafir de tip bujor. ",
    images: [cloudyWhite],
  },
  {
    id: 594,
    name: "Velvet Mauve",
    price: "1050 lei",
    description:
      "Buchet format din hortensie, eustome, trandafiri si eucalipt. ",
    images: [velvetMauve],
  },
  {
    id: 595,
    name: "Petal Mist",
    price: "750 lei",
    description:
      "Buchet format din hortensie, crizanteme, trandafiri crenguta, trandafir cu un cap si eucalipt. ",
    images: [petalMist],
  },
  {
    id: 596,
    name: "Sweet Mint",
    price: "700 lei",
    description:
      "Buchet format din crizanteme, eustome, trandafiri de tip bujor, eustome si eucalipt. ",
    images: [sweetMint],
  },

  {
    id: 1501,
    name: "Alpine Petals",
    price: "830 lei",
    description:
      "Buchet format din lalele, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [alpinePetals],
  },
  {
    id: 1502,
    name: "Blush Cascade",
    price: "2700 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor si eustome. ",
    images: [blushCascade],
  },
  {
    id: 1503,
    name: "Blush Theory",
    price: "5300 lei",
    description:
      "Cos elegant format din trandafiri de tip bujor, lalele, frezie, ranuculus si eucalipt. ",
    images: [blushTheory],
  },
  {
    id: 1504,
    name: "Luna Bloom",
    price: "2500 lei",
    description:
      "Buchet format din trandafir de tip bujor, lalele si eucalipt. ",
    images: [lunaBloom],
  },

  {
    id: 1506,
    name: "Moonlit Roses",
    price: "1100 lei",
    description:
      "Buchet format din trandafir de tip bujor, eustome si eucalipt. ",
    images: [moonlitRoses],
  },
  {
    id: 1507,
    name: "Petal Muse",
    price: "3200 lei",
    description:
      "Buchet format din hortensie, trandafir de tip bujor, crizanteme, ranuculus si frezie. ",
    images: [petalMuse],
  },
  {
    id: 1508,
    name: "Pink Aura",
    price: "1200 lei",
    description:
      "Buchet format din hortensie, trandafiri Sofia, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [pinkAura],
  },
  {
    id: 1509,
    name: "Pure White",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, crizanteme, ranuculus, trandafir de tip bujor, gipsofila si eucalipt. ",
    images: [pureWhite],
  },
  {
    id: 1511,
    name: "Signature Pink",
    price: "1250 lei",
    description:
      "Buchet format din hortensie, crizanteme, eustome, trandafir de tip bujor si eucalipt. ",
    images: [signaturePink],
  },
  {
    id: 1514,
    name: "Wild honey",
    price: "850 lei",
    description:
      "Buchet format din hortensie, trandafiri Sofia, dhiantus, trandafiri Lidia si eucalipt. ",
    images: [wildHoney],
  },

  {
    id: 501,
    name: "Noble Spring",
    price: "950 lei",
    description:
      "Buchet format din hortensie, crizanteme, trandafiri Avalanche, eustome si eucalipt. ",
    images: [noblespring],
  },
  {
    id: 503,
    name: "First Light",
    price: "650 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip crenguta, dianthus si eucalipt.",
    images: [firstlight],
  },
  {
    id: 506,
    name: "Springtime Romance",
    price: "1350 lei",
    description:
      "Buchet format din trandafiri de tip bujor, trandafiri Country si eucalipt.",
    images: [springtimeromance],
  },
  {
    id: 507,
    name: "Ivy",
    price: "1000 lei",
    description:
      "Buchet format din hortensie, trandafiri, eustome si crizanteme.",
    images: [ivy],
  },
  {
    id: 508,
    name: "Soft Rhapsody",
    price: "550 lei",
    description: "Buchet format din hortensie si gipsofila alba.",
    images: [softrhapsody],
  },
  {
    id: 509,
    name: "Zinnia",
    price: "1300 lei",
    description: "Buchet format din trandafiri,eucalipt si asothamus.",
    images: [zinnia],
  },
  {
    id: 510,
    name: "Ethernal Dream",
    price: "1500 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip bujor, oxypetalum si eucalipt.",
    images: [ethernaldream],
  },
  {
    id: 511,
    name: "Awakening",
    price: "450 lei",
    description:
      "Buchet format din lalele de tip bujor cu crengi decorative de primavara. ",
    images: [awakening],
  },
  {
    id: 513,
    name: "Laurel",
    price: "1550 lei",
    description: "Buchet gingas format din 39 de lalele. ",
    images: [laurel],
  },
  {
    id: 514,
    name: "Primrose",
    price: "1150 lei",
    description: "Buchet format din mix de lalele si gispofila alba. ",
    images: [primrose],
  },
  {
    id: 516,
    name: "Mixed Dreams",
    price: "750 lei",
    description:
      "Buchet format din trandafiri de tip bujor, eustome, crizanteme, trandafiri de tip Avalanche și eucalipt.",
    images: [mixeddreams],
  },
  {
    id: 517,
    name: "Color Dance",
    price: "2200 lei",
    description:
      "Buchet format din hortensie, bujori, trandafiri de tip bujor, frezie, trandafiri memory si eucalipt.",
    images: [colordance],
  },
  {
    id: 518,
    name: "Secret Mix",
    price: "750 lei",
    description:
      "Buchet format din trandafiri de tip bujor, crizanteme, trandafiri Avalanche eucalipt și eustome.",
    images: [secretmix],
  },
  {
    id: 519,
    name: "Spring Waltz",
    price: "800 lei",
    description:
      "Buchet format din hortensie, gipsofila, trandafiri de tip bujor si eucalipt.",
    images: [springwaltz],
  },
  {
    id: 520,
    name: "Pink Delight",
    price: "1300 lei",
    description:
      "Buchet format din trandafiri de tip bujor si verdeata decorativa.",
    images: [pinkdelight],
  },
  {
    id: 521,
    name: "Silk Spring",
    price: "550 lei",
    description:
      "Buchet format din trandafiri Sofia, dianthus, trandafiri crenguta si eucalipt.",
    images: [silkspring],
  },
  {
    id: 522,
    name: "Royal Garden",
    price: "1400 lei",
    description:
      "Buchet format din hortensie, trandafiri de tip crenguta, trandafiri rosii si eucalipt.",
    images: [royalgarden],
  },
  {
    id: 524,
    name: "Hydrangea Melody",
    price: "3000 lei",
    description:
      "Buchet specgtaculos format din 7 hortensii si mix de trandafiri. ",
    images: [hydrangeamelody],
  },
  {
    id: 525,
    name: "Spring Radiance",
    price: "950 lei",
    description: "Buchet elegant compus din 21 de lalele. ",
    images: [springRadiance],
  },
  {
    id: 527,
    name: "Softly Spoken",
    price: "950 lei",
    description: "Buchet elegant format din 21 de lalele.",
    images: [softlySpoken],
  },
  {
    id: 530,
    name: "Tulip Reverie",
    price: "1800 lei",
    description: "Buchet elegant format din 45 de lalele rosii și eucalipt.",
    images: [tulipReverie],
  },
  {
    id: 531,
    name: "Delicate Spring",
    price: "1400 lei",
    description: "Buchet elegant format din 35 de lalele roz.",
    images: [delicateSpring],
  },
  // {
  //   id: 511,
  //   name: "Spring Elegance",
  //   price: "750 lei",
  //   description:
  //     "Buchet elegant din lalele de tip bujor, trandafiri si eucalipt.",
  //   images: [springElegance],
  // },
  {
    id: 534,
    name: "Spring Poetry",
    price: "2000 lei",
    description: "Buchet rafinat format din lalele de tip bujor.",
    images: [springPoetry],
  },
  {
    id: 536,
    name: "Bloom",
    price: "2200 lei",
    description:
      "Buchet superb format din trandafiri de tip Bujor, lalele și eucalipt.",
    images: [bloom],
  },
  {
    id: 538,
    name: "Ethereal Blush",
    price: "1500 lei",
    description: "Buchet format dintr-un mix de lalele.",
    images: [etherealBlush],
  },
  // {
  //   id: 517,
  //   name: "Colourful Glow",
  //   price: "500 lei",
  //   description: "Buchet format din fresie, lalele si astromerie.",
  //   images: [colourfulGlow],
  // },

  {
    id: 540,
    name: "Pale Symphony",
    price: "1400 lei",
    description:
      "Buchet elegant compus din hortensie, crizanteme, trandafiri de tip bujor, orhidei, gipsofila și eucalipt. ",
    images: [paleSymphony],
  },
  {
    id: 544,
    name: "Petal Embrace",
    price: "600 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor, crizanteme și gipsofila.",
    images: [petalEmbrace],
  },
  {
    id: 545,
    name: "Floral Elegance",
    price: "1100 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor si eustome.",
    images: [floralElegance],
  },
  // {
  //   id: 58,
  //   name: "Grace",
  //   price: "1200 lei",
  //   description:
  //     "Buchet elegant format din hortensie, trandafiri de tip bujor si eucalipt.",
  //   images: [grace],
  // },
  {
    id: 550,
    name: "Illume",
    price: "950 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri,eustome si crizanteme.",
    images: [illume],
  },
  {
    id: 551,
    name: "Featherlight",
    price: "800 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor, crizanteme si gipsofila.",
    images: [featherlight],
  },
  {
    id: 554,
    name: "Hydrangea Cascade",
    price: "550 lei",
    description: "Buchet rafinat format din hortensie si gipsofila.",
    images: [hydrangeaCascade],
  },
  {
    id: 555,
    name: "Belle",
    price: "1250 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, dianthus crizanteme si gipsofila.",
    images: [belle],
  },
  {
    id: 557,
    name: "Petal Jewel",
    price: "1600 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, eustome, crizanteme, anthurium si eucalipt.",
    images: [petalJewel],
  },
  {
    id: 559,
    name: "Whispery",
    price: "700 lei",
    description: "Buchet elegant format din crizanteme, trandifiri si eustome.",
    images: [whispery],
  },
  {
    id: 560,
    name: "Roselight",
    price: "800 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri de tip bujor, crizanteme si eustome.",
    images: [roselight],
  },
  {
    id: 562,
    name: "Snowdrop",
    price: "800 lei",
    description: "Buchet elegant format din crizanteme, trandafiri si eustome.",
    images: [snowdrop],
  },
  // {
  //   id: 544,
  //   name: "Pastel Breeze",
  //   price: "650 lei",
  //   description:
  //     "Buchet elegant format din crizanteme, trandafiri, gerbere si dianthus.",
  //   images: [pastelBreeze],
  // },

  {
    id: 563,
    name: "Soothe",
    price: "900 lei",
    description:
      "Buchet elegant format din trandafiri, crizanteme, gerbere si eustome.",
    images: [soothe],
  },
  {
    id: 566,
    name: "Lunar Bliss",
    price: "700 lei",
    description:
      "Buchet elegant format din trandafiri de tip bujor, crizanteme, eustome si eucalipt.",
    images: [lunarBliss],
  },
  {
    id: 567,
    name: "Nobility",
    price: "1050 lei",
    description: "Buchet elegant format dintr-un mix de trandafiri si eustome.",
    images: [nobility],
  },

  {
    id: 568,
    name: "Orchid Mist",
    price: "800 lei",
    description: "Buchet elegant format din hortensie, crizanteme si orhidee.",
    images: [orchidMist],
  },
  {
    id: 570,
    name: "Bloomscape",
    price: "950 lei",
    description:
      "Buchet elegant format din hortensie, crizanteme, trandafiri si eucalipt.",
    images: [bloomscape],
  },
  {
    id: 572,
    name: "Marshmallow Bloom",
    price: "900 lei",
    description: "Buchet elegant format din hortensie, crizanteme si eustome.",
    images: [marshmallowBloom],
  },
  {
    id: 573,
    name: "Angel's Touch",
    price: "700 lei",
    description: "Buchet elegant format din hortensie si gipsofila colorata.",
    images: [angelsTouch],
  },
  {
    id: 575,
    name: "Delicacy",
    price: "750 lei",
    description:
      "Buchet elegant format din hortensie, crizanteme si gipsofila colorata.",
    images: [delicacy],
  },
  {
    id: 578,
    name: "Buttercream",
    price: "800 lei",
    description:
      "Buchet elegant format din trandafiri, gerbere, astromerie, crizanteme si eustome.",
    images: [buttercream],
  },
  {
    id: 581,
    name: "Rose Dream",
    price: "1700 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, wax flower si eucalipt.",
    images: [roseDream],
  },
  {
    id: 582,
    name: "Aura",
    price: "1500 lei",
    description:
      "Buchet elegant format din hortensii, gipsofila colorata si eucalipt.",
    images: [aura],
  },
  {
    id: 584,
    name: "Adore",
    price: "1000 lei",
    description:
      "Buchet elegant format din hortensie, crizanteme, trandafiri si eustome.",
    images: [adore],
  },
  {
    id: 585,
    name: "Eden",
    price: "1700 lei",
    description:
      "Buchet elegant format din hortensie, bujori, crizanteme, trandafiri, eustome si eucalipt.",
    images: [eden],
  },
  {
    id: 586,
    name: "Moonveil",
    price: "1100 lei",
    description:
      "Buchet elegant format din hortensie, trandafiri, crizanteme si eustome.",
    images: [moonveil],
  },
];

export default optMartie;
